<template>
  <el-table :data="tableData" border style="width: 100%;" max-height="400px">
    <el-table-column label="发票号码" prop="no" min-width="120" />
    <el-table-column label="发票代码" prop="code" min-width="120" />
    <el-table-column label="发票校验码" prop="checkCode" min-width="180"/>
    <el-table-column label="开票日期" prop="date" />
    <el-table-column label="发票金额" prop="amount" align="right" min-width="120">
      <template #default="{ row }">
        <span :style="{ color: row.amount < 0 || row.type === '退票' ? '#E6A23C' : '#67C23A', fontWeight: 'bold' }">
          {{ $currency(row.amount) }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="发票类型" prop="type" width="110" align="center">
      <template #default="{ row }">
        <el-tag :type="row.type === '退票' || row.amount < 0 ? 'warning' : 'success'" size="small">
          {{ row.type === '退票' || row.amount < 0 ? '退票' : '正常发票' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="登记日期" prop="createTime" min-width="120"/>
    <el-table-column label="状态" prop="status" width="110" align="center">
      <template #default="{ row }">
        <el-tag :type="row.status === 0 ? 'info' : 'success'" size="small">
          {{ row.status === 0 ? '已退票作废' : '正常' }}
        </el-tag>
      </template>
    </el-table-column>
  </el-table>
</template>
<script lang="ts">
// /api/business/{id}/actions/invoice
// /api/invoice/{id}/actions/detail
import { defineComponent, reactive, toRefs, onMounted, watch } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'

export default defineComponent({
  name: 'InvoiceNumber',
  components: {
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    api: { type: String, required: true, default: '' }
  },
  setup(props) {
    const dataMap = reactive({
      tableData: [],
      async getList() {
        dataMap.tableData = await getPageList(props.api)
      }
    })

    watch(() => props.api, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      dataMap.getList()
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
